import * as React from "react";
import { Switch } from "antd";
import { observer } from "mobx-react-lite";
import { CellInternalBox } from "src/components/Sheet2/components/CellInternalBox";
import { KeyDef } from "src/components/Sheet2/isSymbolKey";
import { PropsCell2Editor } from "src/components/Sheet2/PropsCell2";

export type PropsCell2Switch = {
  makeBool: (value: unknown) => boolean;
  makeValue: (checked: boolean) => unknown;
  onFocus: (e: FocusEvent) => void;
  disabled: boolean;
};

export const Cell2Switch: React.FC<PropsCell2Editor<PropsCell2Switch>> =
  observer(({ cell, editorProps }) => {
    const { store, value, ...cellProps } = cell;
    const { cellKey } = cell;
    const { makeBool, makeValue, onFocus, ...restEditorProps } = editorProps;
    const iref = React.useRef<HTMLElement>(null);
    const refEnter = React.useRef<boolean>(false);

    const onKey = (e: KeyDef) => {
      e.stopPropagation();
      if (e.code === "Enter") {
        refEnter.current = true;
      } else {
        store.onKeyDown(cellKey, e);
      }
    };
    const handleFocus = (e: FocusEvent) => {
      store.activate(cellKey, false);
      onFocus(e);
    };
    React.useEffect(() => {
      const input = iref.current;
      store.updateCell({
        ...cellProps,
        focus() {
          input?.focus?.();
        },
        blur() {
          input?.blur?.();
        },
      });
      input?.addEventListener("focus", handleFocus);
      input?.addEventListener("keydown", onKey);
      return () => {
        input?.removeEventListener("keydown", onKey);
        input?.removeEventListener("focus", handleFocus);
      };
    });
    React.useEffect(() => {
      store.setSrcCellValue(cellKey, value);
    }, [value]);

    return (
      <CellInternalBox store={store} cellKey={cellKey} pos={cell.pos}>
        <div style={{ flex: 1 }}>
          <Switch
            ref={iref}
            {...restEditorProps}
            checked={makeBool(store.cellCurValues[cellKey])}
            onChange={(checked) => {
              store.setValueByKey(cellKey, makeValue(checked));
              if (refEnter.current) {
                store.onEnter();
                refEnter.current = false;
              }
            }}
          />
        </div>
      </CellInternalBox>
    );
  });
